import React from "react";

const SearchBarracks = () => {
  return <div>SearchBarracks</div>;
};

export default SearchBarracks;
